class Overlay {
    constructor() {
        if (Overlay.instance)
            return Overlay.instance

        // Vytvoření overlay elementu
        this.overlay = document.createElement('div');
        this.overlay.id = 'mainOverlay';
        this.overlay.className = 'modal is-clipped';
        this.overlay.style.display = 'none';
        this.overlay.style.zIndex = 10000;

        this.overlay.innerHTML = `
          <div class="modal-background" style="background-color: rgba(0, 0, 0, 0.6);"></div>
          <div class="modal-content has-text-centered p-4 has-background-black" style="margin-top: 5rem !important;">
            <p class="title" id="mainOverlayText">Processing data...</p>
            <!--div class="button is-loading is-large"></div--> <!-- Bulma spinner -->
            <div>
                <img src="${window.static_files_url}/imgs/loading.svg" style="width: 200px" alt="Loading..." />
            </div>
            <p class="title" id="longTimeText" style="visibility: hidden">It can take a while if you process lots of items...</p>
          </div>
        `;

        document.body.appendChild(this.overlay);
        this.textElement = this.overlay.querySelector('#mainOverlayText');
        this.longTimeText = this.overlay.querySelector('#longTimeText');
        this.longTimeTimeout = null;

        Overlay.instance = this
    }

    show(text = 'Processing data...') {
        this.textElement.textContent = text;
        this.overlay.style.display = 'block';
        this.longTimeTimeout = setTimeout(() => {
            this.longTimeText.style.visibility = 'visible';
        }, 5000);
    }

    hide() {
        this.overlay.style.display = 'none';
        clearTimeout(this.longTimeTimeout);
        this.longTimeText.style.visibility = 'hidden';
    }
}

export function injectOverlay(cssSelector, message="Loading...") {
    const el = document.querySelector(cssSelector);
    if(!el){
        return;
    }
    const skeleton = document.createElement("div");
    skeleton.classList.add("skeleton", "py-4", "is-flex", "is-flex-direction-column", "is-align-items-center");
    skeleton.innerHTML = `<img src='/static/imgs/loading.svg' alt='loading...' style='height: 300px' /> <p class='injected-overlay-message mt-3 title is-4 has-text-centered'>${message}</p>`;
    el.innerHTML = "";
    el.appendChild(skeleton);
}


export default Overlay
